import { DocumentProto } from "~/document";
import SearchQuery from "~/searchQuery";
import { TemplateId } from "./stores/templates";

const paths = {
  match: {
    index: "/", //
    docDetail: "/browse/:id",
    browse: "/documents-search/*",
    editDocument: "/edit/:id",
    personalArea: "/personal-area/*",
    uploadDocWithTemplate: "/upload/with-template/:templateId",
    uploadSimilar: `/upload/with-document/:documentId`,
    documents: "/",
    searchRedirect: "/search/results/*",
  },
  construct: {
    docDetail: (documentProto: DocumentProto) => `/browse/${documentProto}`,
    docDetailWithSearchQuery: (documentProto: DocumentProto, query: URLSearchParams) =>
      `/browse/${documentProto}?${query.toString()}`,
    notFound: () => "/not-found/",
    uploadDoc: () => "/upload/",
    uploadDocWithTemplate: (template: TemplateId) => `/upload/with-template/${template}`,
    uploadSimilar: (proto: DocumentProto) => `/upload/with-document/${proto}`,

    editDocument: (protocol: DocumentProto) => `/edit/${protocol}`,
    editDocumentRelations: (protocol: DocumentProto) => `/edit/${protocol}#relations`,
    editDocumentLangVersions: (protocol: DocumentProto) => `/edit/${protocol}#translations`,

    personalArea: () => "/personal-area/",
    documents: () => "/",
    index: () => "/",
    help: () => "/help",
    admin: () => "/admin",
    browse: (searchQuery?: SearchQuery) => {
      if (!searchQuery || searchQuery.isEmpty()) return "/";
      const searchParams = searchQuery.toQueryString();
      for (const [key, value] of searchParams) {
        if (value.toString().trim() === "") searchParams.delete(key);
      }
      const searchString = searchParams.toString();
      const path = `/documents-search/?${searchString}`;
      return path;
    },
    statistics: () => "/statistics/",
    advancedSearch: (searchQuery?: SearchQuery | null) => {
      if (!searchQuery || searchQuery.isEmpty()) return "/advanced-search/";
      const searchParams = searchQuery.toQueryString();
      const searchString = searchParams.toString();
      const path = `/advanced-search/?${searchString}`;
      return path;
    },
    savedSearchManagement: () => `/personal-area#saved`,
  },
};

export default paths;
